// === テーマ切替: Light → Dark → Auto ===
var themeToggle = document.getElementById('theme-toggle');
if (themeToggle) {
  themeToggle.addEventListener('click', function() {
    var current = localStorage.getItem('theme');
    var next;
    if (current === 'light') {
      next = 'dark';
    } else if (current === 'dark') {
      next = 'auto';
    } else {
      next = 'light';
    }

    if (next === 'dark') {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else if (next === 'light') {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    } else {
      localStorage.removeItem('theme');
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }
  });
}

// === モバイルメニュートグル ===
var menuToggle = document.getElementById('menu-toggle');
var mobileMenu = document.getElementById('mobile-menu');

if (menuToggle && mobileMenu) {
  menuToggle.addEventListener('click', function() {
    var isOpen = !mobileMenu.classList.contains('hidden');
    mobileMenu.classList.toggle('hidden');
    menuToggle.classList.toggle('menu-open');
    menuToggle.setAttribute('aria-expanded', String(!isOpen));
  });
}

// === モバイル検索トグル ===
var searchToggle = document.getElementById('search-toggle');
var mobileSearch = document.getElementById('mobile-search');
var mobileSearchInput = document.getElementById('mobile-search-input');

if (searchToggle && mobileSearch) {
  searchToggle.addEventListener('click', function() {
    mobileSearch.classList.toggle('hidden');
    if (!mobileSearch.classList.contains('hidden') && mobileSearchInput) {
      mobileSearchInput.focus();
    }
  });
}

// === クライアントサイド検索 ===
var searchInput = document.getElementById('search-input');
var searchResults = document.getElementById('search-results');
var mobileSearchResults = document.getElementById('mobile-search-results');

var searchDataPromise = fetch('/index.json')
  .then(function(resp) { return resp.json(); })
  .catch(function() { return []; });

function renderResults(matches, container) {
  if (!container) return;
  if (matches.length) {
    container.innerHTML = matches.map(function(m) {
      return '<a href="' + m.url + '" class="block px-3.5 py-2.5 text-sm text-stone-700 dark:text-stone-300 hover:bg-stone-50 dark:hover:bg-stone-700 border-b border-stone-100 dark:border-stone-700 last:border-0 transition-colors">' + m.title + '</a>';
    }).join('');
    container.classList.remove('hidden');
  } else {
    container.innerHTML = '<div class="px-3.5 py-2.5 text-sm text-stone-400">見つかりませんでした</div>';
    container.classList.remove('hidden');
  }
}

function performSearch(query, resultsContainer) {
  if (!query) {
    if (resultsContainer) resultsContainer.classList.add('hidden');
    return;
  }
  searchDataPromise.then(function(data) {
    var matches = data.filter(function(p) {
      return p.title.includes(query) ||
        (p.tags && p.tags.some(function(t) { return t.includes(query); }));
    }).slice(0, 20);
    renderResults(matches, resultsContainer);
  });
}

// デスクトップ検索
if (searchInput) {
  searchInput.addEventListener('input', function() {
    performSearch(searchInput.value.trim(), searchResults);
  });
}

// モバイル検索
if (mobileSearchInput) {
  mobileSearchInput.addEventListener('input', function() {
    performSearch(mobileSearchInput.value.trim(), mobileSearchResults);
  });
}

// クリック外で閉じる
document.addEventListener('click', function(e) {
  if (searchResults && !searchResults.contains(e.target) && e.target !== searchInput) {
    searchResults.classList.add('hidden');
  }
  if (mobileSearchResults && !mobileSearchResults.contains(e.target) && e.target !== mobileSearchInput) {
    mobileSearchResults.classList.add('hidden');
  }
});
